import { render } from "./setPassword.vue?vue&type=template&id=1c6b8bad&scoped=true"
import script from "./setPassword.vue?vue&type=script&lang=js"
export * from "./setPassword.vue?vue&type=script&lang=js"

import "./setPassword.vue?vue&type=style&index=0&id=1c6b8bad&scoped=true&lang=scss"

import exportComponent from "F:\\webWork\\demo\\h5sdk2\\h5sdk3.muugame.com\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6b8bad"]])

export default __exports__